<template>
  <div>
    <h1 class="font-semibold text-xl">Overview</h1>
    <Aggregates class="mb-4" />
    <Charts />
  </div>
</template>

<script>
import Aggregates from '../component/Aggregates.vue';
import Charts from '../component/Charts.vue';

export default {
  name: 'dashboard',
  components: {
    Aggregates,
    Charts,
  },
};
</script>
